import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function ShoppingCart(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, sx, viewBox, "data-tidal": "TidalIllustration", "data-tidal-illustration": "ShoppingCart", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.primary.light,
        d: "M42.606 11.25H11.25l1.5 21h1.5v-.008l24.996-1.372a3.11 3.11 0 0 0 3.067-2.37l3.368-13.62a3.045 3.045 0 0 0-3.075-3.63Z"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: theme.vars.palette.secondary.main, d: "m44.91 18-.367 1.5h-32.7L11.73 18h33.18Z" }),
    /* @__PURE__ */ jsx("path", { fill: theme.vars.palette.secondary.dark, d: "m43.425 24-.368 1.5H12.27l-.113-1.5h31.268Z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.secondary.main,
        d: "m23.985 31.71-.735-20.46h-1.5v.03l.735 20.498v.015l1.5-.083Zm9.803-.54.712-19.89v-.03H33l-.712 19.927a.256.256 0 0 0 .007.076l1.492-.083Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.secondary.dark,
        d: "M38.25 35.25h-24L12.945 6.546A4.5 4.5 0 0 0 8.45 2.25h-4.7a1.5 1.5 0 0 0 0 3h4.567a1.5 1.5 0 0 1 1.5 1.432l1.304 28.704a3 3 0 0 0 3 2.864H19.5V39h3v-.75H33V39h3v-.75h2.25a1.5 1.5 0 1 0 0-3Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.primary.dark,
        d: "M3.75 2.25h4.5v3h-4.5a1.5 1.5 0 0 1 0-3ZM21 45.75a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5Z"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: theme.vars.palette.secondary.main, d: "M21 43.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z" }),
    /* @__PURE__ */ jsx("path", { fill: theme.vars.palette.primary.dark, d: "M34.5 45.75a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5Z" }),
    /* @__PURE__ */ jsx("path", { fill: theme.vars.palette.secondary.main, d: "M34.5 43.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z" })
  ] });
}
ShoppingCart.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "ShoppingCart"
};
validateTidalLicense();
export {
  ShoppingCart
};
//# sourceMappingURL=ShoppingCart.js.map
